var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"text-center mb-4 headline"},[_vm._v(_vm._s(_vm.title))]),_c('germination-percentage',{staticClass:"d-flex flex-column justify-center elevation-2 rounded-lg percentage py-2 mb-6",attrs:{"stats":_vm.stats}}),_c('canvas',{attrs:{"id":_vm.id,"width":"500","height":"350"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }